﻿import React, { useState } from "react";
import { Box, Typography, Button, Stack, Card, Container } from "@mui/material";
import { useNavigate } from "react-router-dom";
import PopUp from "@/components/PopUp/PopUp";
import SettingsPopUp from "@/components/Settings/SettingsPopUp";
import { LinkButton } from "@/components/SummaryCard/SummaryCard";
import "./SummaryCard.css";
import {
  SummaryInactive,
  SummaryHover,
  ManagerInactive,
  ManagerHover,
  ConnectionSettings,
} from "../../ImageRepo";
import { Link } from "react-router-dom";

const SummaryCard = ({ stageName, connectionPairName, isGlobal = false }) => {
  const navigate = useNavigate();

  return (
    <Container>
      <Card
        style={{
          display: "flex",
          justifyContent: "flex-start",
          margin: "unset",
        }}
      >
        <Box>
          <img className="summary-icon" src={ConnectionSettings} />
        </Box>
        <Box className="settings-summary-panel">
          <Typography
            gutterBottom
            variant="h1"
            className="settings-summary-panel-heading"
          >
            {isGlobal ? "Global Settings" : "Connection Settings"}
          </Typography>
          <Box className="settings-summary-content">
            <Typography
              className="settings-summary-content-count"
              variant="body1"
            >
              Stage:
            </Typography>
            <Typography
              className="settings-summary-content-description"
              variant="body1"
            >
              {stageName}
            </Typography>
          </Box>
          {!isGlobal && (
            <Box className="settings-summary-content">
              <Typography
                className="settings-summary-content-count"
                variant="body1"
              >
                Connection Profile:
              </Typography>
              <Typography
                className="settings-summary-content-description"
                variant="body1"
              >
                {connectionPairName}
              </Typography>
            </Box>
          )}
        </Box>
        <Box className="settings-summary-btn-container">
          <Stack
            direction={"row"}
            justifyContent={"space-between"}
            style={{ width: 612 }}
          >
            <LinkButton
              onClick={() => navigate("/manager")}
              label={"Manager"}
              imgSrc={ManagerInactive}
              imgSrcHover={ManagerHover}
            />
            <LinkButton
              onClick={() => navigate("/summary")}
              label={"Summary"}
              imgSrc={SummaryInactive}
              imgSrcHover={SummaryHover}
            />
          </Stack>
        </Box>
      </Card>
    </Container>
  );
};

export default SummaryCard;
